import css from "styled-jsx/css";

export const componentStyles = css`
  .tag {
    display: inline-flex;
    padding: 4px 8px;
    border: 1px solid;
    border-radius: 14px;
    font-size: 0.75em;
    font-weight: 400;
  }
`;
